import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import CAR from "../../../Images/customer/policy-car.svg";
import TWO from "../../../Images/customer/policy-bike.svg";
import HLT from "../../../Images/customer/policy-health.svg";
import INV from "../../../Images/customer/policy-investment.svg";
import PolicyList from "../PolicyList/PolicyList";
import { showToaster } from "../../toster";
import ClaimOtp from "./ClaimOtp";

const ClaimInt = () => {
    const [IsClaimList, setIsClaimList] = useState([]);
    const token = localStorage.getItem("smc-csp-token");
    const [policyList, setPolicyList] = useState([]);
    const [loading, setLoading] = useState(true);  // New loading state
    const [error, setError] = useState(null);
    const [GetResponse, setGetResponse] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();


    const handleLoading = (isLoading) => {
        setLoading(isLoading);
    };
    const getPolicyList = (data) => {
        setPolicyList(data);
    }
    const getClaimDetails = (ClaimDetails) => {
        navigate("/claim-details", { state: { ClaimDetails } });
    };
    console.log(policyList, "Claim p Data")
    const Claim = async () => {
        try {
            const response = await axios.post(
                "https://www.smcinsurance.com/CustomerPanelApi/Api/Policies/GetClaimDetails",
                {}, // Empty object if there's no request body
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            //console.log(response.data.Data.ClaimsList, "Claim Intimation");
            setIsClaimList(response.data.Data.ClaimsList);
            setLoading(false);
        } catch (error) {
            console.error("Error submitting policy syncing request:", error);
            alert("Failed to submit policy syncing request. Please try again.");
        }
    };

    //const Policy NuFamilyListData.find(member => member.RelationName

    const policyClaim = location.state?.policyClaim || {}; // Default to an empty object if undefined


    const sendOtp = async (item) => {
        //if (!item) {
        //    console.error("Received undefined item in sendOtp");
        //} else {
        //    console.log("Claiming for:", item);
        //}
        const COTP = { PolicyNo: item.PolicyNo || null };
        try {
            const response = await axios.post(
                "https://crmapi.smcinsurance.com:8081/api/External/RetailCustomerOTPSent",
                COTP,
                {
                    headers: {
                        Token: "d41d8cd98f00b204e9800998ecf8427e",
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response.status === 200 && response.data.message === "OTP sent successfully") {
                showToaster({
                    message: "OTP sent",
                    type: "success",
                });
                setGetResponse(response.data)

            } else {
                showToaster({
                    message: "Sorry, the Policy Number did not match our records.",
                    type: "error",
                });
            }
        } catch (error) {
            showToaster({
                message: "An error occurred while sending the OTP. Please try again.",
                type: "error",
            });
        }
    };
    
    useEffect(() => {
        Claim();
    }, []);

    return (
        <>
            {!GetResponse ?
                <>
                    <h4>Claim Intimation</h4>
                    <div className="ClaimStatus">
                        <ul>
                            <li>
                                <p>Approve</p>
                                <span>0</span>
                            </li>
                            <li>
                                <p>Intimated</p>
                                <span>0</span>
                            </li>
                            <li>
                                <p>In Process</p>
                                <span>0</span>
                            </li>
                            <li>
                                <p>Rejected</p>
                                <span>0</span>
                            </li>
                            <li>
                                <p>Pending</p>
                                <span>0</span>
                            </li>
                        </ul>
                    </div>
                    <h4>Claim Intimation</h4>
                    {loading ? (  // Show loader when loading
                        <div className="ProductLoader">
                        </div>
                    ) : IsClaimList && IsClaimList.length > 0 ?
                        <div className="Endorsement box-1">
                            {IsClaimList && IsClaimList.length > 0 && IsClaimList.map((item, index) => (
                                <div className="Policy-Card" key={index}>
                                    {(item.PolicyType === "CAR" || item.PolicyType === "Motor") && (
                                        <div className="col-1 text-center">
                                            <img alt="" src={CAR} />
                                            <p>Car</p>
                                        </div>
                                    )}
                                    {item.PolicyType === "TWO" && (
                                        <div className="col-1 text-center">
                                            <img alt="" src={TWO} />
                                            <p>Two Wheeler</p>
                                        </div>
                                    )}
                                    {item.PolicyType === "HLT" && (
                                        <div className="col-1 text-center">
                                            <img alt="" src={HLT} />
                                            <p>Health</p>
                                        </div>
                                    )}
                                    {item.PolicyType === "INV" && (
                                        <div className="col-1 text-center">
                                            <img alt="" src={INV} />
                                            <p>Health</p>
                                        </div>
                                    )}
                                    <div className="col-2">
                                        <span>{item.ClaimDate}</span>
                                    </div>
                                    <div className="col-3">
                                        <span>{item.ClaimDesc}</span>
                                    </div>
                                    <div className="col-2">
                                        <span>{item.ClaimStatus}</span>
                                    </div>
                                    <div className="col-2">
                                        <div className="ActionBTN">
                                            <a onClick={(e) => getClaimDetails(item)}>
                                                View Details
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        :
                        <div class="alert alert-danger" role="alert">
                            <i class="fas fa-exclamation-triangle"></i> No data of <b>Claim Intimation</b>
                        </div>
                    }
                    <div className="mt-4">
                        <h4>
                            My policies ({policyList?.length > 0 ? policyList?.length : "0"})
                        </h4>
                        <PolicyList
                            ReportClaim={sendOtp}
                            onSendData={getPolicyList}
                            onLoading={handleLoading}  // Send loading state function to child
                        />
                    </div>
                </>
                :
                <>
                    <h4>Claim Intimation</h4>
                    <ClaimOtp MobileNo={GetResponse.mobile} EmailID={GetResponse.email} PolicyNo={policyClaim.PolicyNo} />
                </>
            }
        </>
    );
};

export default ClaimInt;
